(($) => {

  const slides = document.querySelectorAll(".item");
  let curSlide = 0;
  let maxSlide = slides.length - 1;
  let audioPlayer = null;
  let isPlaying = false;
  let isMuted = false;

  // get active corousel item
  function getActiveItem(key) {
    return $(slides[key])
  }

  // events to carousel button (next, prev)
  const carouselButonEvent = (key) => {

    // add style to slide item
    function addTranslate(curSlide){
      slides.forEach(function (item, index) {
        item.style.transform = `translateX(${100 * (- curSlide)}%)`;
      })
    }

    const prev = () => {

      getActiveItem(curSlide).removeClass("active");

      curSlide === 0 ? curSlide = maxSlide : curSlide--;

      getActiveItem(curSlide).addClass("active");

      addTranslate(curSlide);
    }

    const next = () => {

      getActiveItem(curSlide).removeClass("active");

      curSlide === maxSlide ? curSlide = 0 : curSlide++;

      getActiveItem(curSlide).addClass("active");

      addTranslate(curSlide);
    }

    const actions = {
      prev,
      next
    };

    return actions[key];
  }

  const playerActions = (key) => {

    audioPlayer = getActiveItem(curSlide).find("audio");

    function toggleIsPlaying() {
      return isPlaying = !isPlaying;
    }

    function toggleIsMuted() {
      return isMuted = !isMuted;
    }

    const play = () => {
      if(isPlaying) {
        toggleIsPlaying();
        return audioPlayer.get(0).pause();
      }

      toggleIsPlaying();
      return audioPlayer.get(0).play();
    }

    const mute = () => {
      getActiveItem(curSlide).find("#mute").toggleClass("d-none");
      audioPlayer.get(0).muted = toggleIsMuted();
    }

    const reset = () => {
      audioPlayer.get(0).pause();
      audioPlayer.get(0).currentTime = 0;
      audioPlayer.get(0).muted = false;

      getActiveItem(curSlide).find("#mute").addClass("d-none");

      isPlaying = false;
      isMuted = false;
      audioPlayer = null;
    }

    const actions = {
      play,
      mute,
      reset
    };

    return actions[key];
  }

  $(".furb-fm .lista .acoes img").on("click", function () {
    const action = $(this).data("action");
    const execute = carouselButonEvent(action);
    const resetPlayer = playerActions("reset");

    resetPlayer();
    execute();
  })

  $(".furb-fm .furb-fm__botoes img").on("click", function () {
    const action = $(this).data("action");
    const execute = playerActions(action);

    execute();
  });
})(jQuery);
